import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import extractText from 'flarum/common/utils/extractText';
/**
 * One error alert of the same words at a time: several requests of a page
 * failing together (a species page fires ~8) no longer stack up as many
 * "Oups, une erreur est survenue…" - the one already shown stands for them
 * all. Core does as much for network failures only (its networkErrorAlert);
 * see retryFailedReads.ts, which spares most of them a first alert at all.
 */
export default function showErrorAlertOnce() {
  override(app.alerts, 'show', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    // show(children), show(attrs, children), show(componentClass, attrs, children).
    const attrs = args.length >= 2 ? args[args.length - 2] : {};
    const children = args[args.length - 1];
    if (attrs?.type === 'error') {
      const text = extractText(children);
      const active = app.alerts.getActiveAlerts();
      const shown = Object.keys(active).find(key => active[key].attrs?.type === 'error' && extractText(active[key].children) === text);
      if (shown !== undefined) return Number(shown);
    }
    return original(...args);
  });
}